import styled from '@emotion/styled';
import { Text } from '~/shared/components';
import { StyledCloseIcon } from '~/features/productList/components/FilterBar/SelectedFacets/SelectedFacets.styles';
import { theme } from '~/theme';

export const StyledMessage = styled(Text)(() => ({
    background: theme.colors.greenLight,
    padding: theme.space[2],
    marginTop: theme.space[3],
}));

export const ErrorMessage = styled(Text)(() => ({
    ...theme.mixins.useTextStyle('bodySmall'),
    color: theme.colors.negative,
    marginTop: '8px',
}));

export const StyledButtonWrapper = styled.div(() => ({
    borderTop: `1px solid ${theme.colors.grey40}`,
    padding: theme.space[3],
    width: '100%',
    position: 'fixed',
    left: 0,
    background: theme.colors.white,
    bottom: 0,
}));

export const StyledDropPointWrapper = styled.div(() => ({
    padding: `0 ${theme.space[4]}`,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: `${theme.colors.white}`,
    height: '-webkit-fill-available',
    overflowY: 'auto',
}));

export const DropPointCloseWrapper = styled.div(() => ({
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingTop: theme.space[3],
}));

export const DropPointCloseIcon = styled(StyledCloseIcon)(() => ({
    width: 15,
    height: 15,
    marginLeft: theme.space['2'],
    marginTop: 2,
    cursor: 'pointer',
    padding: 0,
    ':focus-visible': {
        boxShadow: theme.shadows.accessibility,
    },
}));

export const StyledTitle = styled.div(() => ({
    fontSize: theme.fontSizes.lg,
    paddingTop: theme.space[3],
    marginBottom: theme.space[3],
    fontWeight: theme.fontWeights.medium,
    textTransform: 'uppercase',
}));

export const StyledSubTitle = styled.div(() => ({
    fontSize: theme.fontSizes.sm,

    marginBottom: theme.space[3],
}));

export const StyledDeliveryAddressSummary = styled.div(() => ({
    marginTop: theme.space[3],
    maxWidth: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    border: `1px solid ${theme.colors.black}`,
    borderRadius: theme.space[1],
}));
